import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { OktaService } from './okta.service';
import { environment } from '../../../environments/environment';

export interface CatalogListElement {
    'id': number,
    'name': string,
    'item': number,
    'type': string,
    'productLine': string,
    'status': string, 
    'SLA': string,
    'published': boolean,
    'revisionDate': string
}

export interface FullImageElement {
    'id': number,
    'uploadID': string,
    'type': string,
    'caption': string,
    'fileName': string,
    'visibleInSheet': boolean,
    'data'?: File,
    'uploadState': number,
    'placement': string
}

export interface ImageElement {
    'id': string,
    'fileName': string,
    'visibleInSheet': boolean,
    'type': string,
    'caption': string,
    'placement': string
}

export interface SuccessStoryElement {
    'id': number,
    'title': string,
    'url': string,
    'metrics': MetricElement[]
}

export interface MetricElement {
    'id': number,
    'name': string
}

export interface IconElement {
    'svgURL': string,
    'pngURL': string,
    'base64URL' : string
}

@Injectable()
export class ProductService {
    catalogList: BehaviorSubject<CatalogListElement[] | null> = new BehaviorSubject<CatalogListElement[] | null>(null);
    loadFailed = false;

    constructor(private http: HttpClient, private oktaService: OktaService) { };

    get catalogUpdated(): Observable<CatalogListElement[] | null> {
        return this.catalogList.asObservable();
    }

    refresh() {
        this.loadFailed = false;

        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };

        this.http.get<any>(environment.azure.url + '/catalog', options)
            .subscribe({
                next: data => {
                    let loadedItems: CatalogListElement[] = [];
                    data.forEach((item: any) => {
                        loadedItems.push(item);
                    });
                    this.catalogList.next(loadedItems);
                    this.loadFailed = false;
                },
                error: msg => {
                    this.loadFailed = true;
                    this.catalogList.next(null);
                    console.log(msg);
                }
            });
    }
}
